import threadNames from "@/utils/thread-names.js";
import moment from "moment";

export default {
  data() {
    return {
      lpChart: {
        data: null,
        extraOptions: null
      },
      lrChart: {
        data: null,
        extraOptions: null
      },
      lcpChart: {
        data: null,
        extraOptions: null
      },
      impChart: {
        data: null,
        extraOptions: null
      },
      eChart: {
        data: null,
        extraOptions: null
      }
    };
  },
  computed: {
    progressPerThread() {
      let usersProgress = [];
      let threads = [];

      if (
        this.activeUser &&
        this.activeUser.assessmentStates &&
        this.activeUser.assessmentStates[0]
      ) {
        this.activeUser.assessmentStates[0].threads.forEach(thread => {
          const catchupState = this.activeUser.catchupStates.find(
            catchupState =>
              catchupState.assessmentId ===
              this.activeUser.assessmentStates[0]._id
          );
          const conceptMastery = catchupState.threads.find(
            threadState => threadState.threadId === thread.threadId
          ).conceptMastery;

          if (conceptMastery) {
            const mastered = conceptMastery.filter(concept => concept === 3)
              .length;

            if (mastered === conceptMastery.length) {
              usersProgress.push(100);
            } else {
              usersProgress.push(thread.progress);
            }
            threads.push(thread.threadName);
          }
        });
      }
      return { data: usersProgress, labels: threads };
    },
    resultsPerThread() {
      let usersResults = [];
      let threads = [];
      if (
        this.activeUser &&
        this.activeUser.assessmentStates &&
        this.activeUser.assessmentStates[0]
      ) {
        this.activeUser.assessmentStates[0].threads.forEach(thread => {
          let correctThreadFeedback = this.activeUser.assessmentStates[0].feedback.find(
            item => item.threadId == thread.threadId
          );
          usersResults.push(
            correctThreadFeedback ? correctThreadFeedback.gradeMastered : -1
          );
          threads.push(thread.threadName);
          // usersResults.push(
          //   correctThreadFeedback ? correctThreadFeedback * (100 / 9) : 0
          // );
        });
      }
      return { data: usersResults, labels: threads };
    },
    momentFromNow() {
      let data = [];
      if (this.activeUser.engagement) {
        let engagements = this.activeUser.engagement.dates;
        this.daysOfTheWeek.forEach((day, index) => {
          let currentDay = moment().subtract(index, "days");
          let count = 0;
          engagements.forEach(date => {
            if (moment(date.date).isSame(currentDay, "day")) {
              count = count + date.sum;
            }
          });
          data.push(count);
        });
      } else {
        this.daysOfTheWeek.forEach(() => data.push(0));
      }
      return { data: data.reverse() };
    },
    improvementsPerThread() {
      let output = {
        initial: [],
        reassess: [],
        labels: []
      };
      if (this.activeUser && this.activeUser.improvement) {
        let assessmentType = this.activeUser.assessmentStates[0].type;
        let iterator = 0;
        Object.keys(this.activeUser.improvement[this.currentSubject]).forEach(
          threadId => {
            iterator++;
            //bugfix english having >4 threads
            if (iterator > 4 && assessmentType.startsWith("ENGLISH")) {
              return;
            }
            let initial = this.activeUser.improvement[this.currentSubject][
              threadId
            ].find(entry => entry.reassessment === false).relGradeMastered;
            let reassessments = this.activeUser.improvement[
              this.currentSubject
            ][threadId].filter(entry => {
              if (entry.reassessment === true) return entry;
            });
            let reassess = reassessments.map(entry => entry.relGradeMastered);
            output.initial.push(initial);
            output.reassess.push(reassess);
            output.labels.push(threadNames[assessmentType][threadId]);
          }
        );
      }
      return output;
    },
    learnerCatchupJourney() {
      let output = {
        mastered: [],
        done: [],
        togo: [],
        labels: []
      };
      this.activeUser.assessmentStates[0].threads.forEach(thread => {
        //find feedback for this thread in feedback
        output.labels.push(thread.threadName);
        if (this.activeUser.assessmentStates[0].feedback.length > 0) {
          let feedback = this.activeUser.assessmentStates[0].feedback.find(
            matchingThread => matchingThread.threadId === thread.threadId
          );
          if (feedback) {
            let i = [];
            let totalMasetered = feedback.conceptMastery.filter(
              concept => concept === 3
            ).length;
            feedback.conceptMastery.forEach((concept, index) => {
              if (concept !== 3) {
                i.push(index);
              }
            });
            let done = this.conceptsDone(i, this.activeUser.assessmentStates[0]._id, thread.threadId);
            let unmastered =
              feedback.conceptMastery.length - totalMasetered - done;
            output.mastered.push(totalMasetered);
            output.done.push(done);
            output.togo.push(unmastered);
          } else {
            output.mastered.push(0);
            output.done.push(0);
            output.togo.push(0);
          }
        }
      });
      return output;
    }
  },
  methods: {
    conceptsDone(unmasteredConceptsList, assessmentId, threadId) {
      if (this.activeUser.catchupStates) {
        let currentConcept = this.activeUser.catchupStates.find(
          state => state.assessmentId === assessmentId
        ).threads[threadId - 1].stage.concept;

        if (currentConcept === 0) {
          return 0;
        } else {
          let isIndexThere = unmasteredConceptsList.findIndex(
            index => index === currentConcept - 1
          );
          if (isIndexThere === -1) {
            return unmasteredConceptsList.length;
          } else {
            return isIndexThere;
          }
        }
      }
    }
  }
};
